<!------------ START TEMPLATE ------------>
<template>
  <div class="vx-row">
    <div
      class="vx-col sm:w-1/2 w-full mb-4"
      :key="indextr"
      v-for="(pergunta, indextr) in perguntasVisiveis"
    >
      <label for="" class="vs-select--label">{{ pergunta.pergunta }}</label>
      <v-select
        v-if="pergunta.respostasPossiveis"
        :options="pergunta.respostasPossiveis"
        :name="`Resposta ${indextr + 1}`"
        :id="`Resposta ${indextr + 1}`"
        v-model="pergunta.resposta"
        label="item"
        :reduce="(item) => item"
        v-validate="{ required: true }"
        :state="validateState(`Resposta ${indextr + 1}`)"
        :class="validateClass(`Resposta ${indextr + 1}`)"
        @input="onChangeSelectData"
      ></v-select>

      <vs-textarea
        v-if="pergunta.isAberta"
        class="select-large w-full"
        :name="`Resposta ${indextr + 1}`"
        id="textarea"
        v-model="pergunta.resposta"
        v-validate="{ required: true }"
        @change="onChangeTextAreaData"
        :state="validateState(`Resposta ${indextr + 1}`)"
        :class="validateClass(`Resposta ${indextr + 1}`)"
      />
    </div>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import service from "../../../services";
import vSelect from "vue-select";
export default {
  components: { vSelect },
  props: ["checklist"],
  watch: {
    checklist() {
      if (this.checklist) {
        this.perguntas = this.checklist;
        this.filtraPerguntasVisiveis();
      }
    },
  },
  data() {
    return {
      perguntas: [],
      perguntasVisiveis: [],
    };
  },
  methods: {
    onChangeTextAreaData() {
      this.$emit("formAlterado", this.perguntas);
    },
    onChangeSelectData() {
      this.validaResposta();
      this.$emit("formAlterado", this.perguntas);
    },
    buscaDados() {
      this.$vs.loading();

      const objSend = {
        idEvento: this.$route.params.idEvento,
        idEnvolvido: null,
        epico: "Pré-Abertura",
      };

      service
        .post("Eventos", "BuscarPerguntas", objSend)
        .then((res) => {
          if (!this.checklist) {
            this.perguntas = res.data.map((pergunta) => ({
              ...pergunta,
              respostasPossiveis: pergunta.respostasPossiveis
                ? ["Selecione", ...pergunta.respostasPossiveis.split(",")]
                : null,
              resposta:
                pergunta.resposta && pergunta.ismultiplaEscolha
                  ? pergunta.resposta.split(",")
                  : pergunta.resposta,
            }));
            this.validaResposta();
          }

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    filtraPerguntasVisiveis() {
      this.perguntasVisiveis = this.perguntas
        .filter((pergunta) => pergunta.show)
        .sort((a, b) => a.ordenacao - b.ordenacao);
    },
    shouldShow(item) {
      if (!item.idPerguntaDependente) {
        return true;
      }

      const perguntaDependente = this.perguntas.find(
        (x) => x.idPergunta == item.idPerguntaDependente
      );
      return (
        perguntaDependente &&
        perguntaDependente.resposta == item.respostaDependente
      );
    },
    validaResposta() {
      this.perguntas.forEach(
        (element) => (element.show = this.shouldShow(element))
      );
      this.filtraPerguntasVisiveis();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
  },
  mounted() {
    this.buscaDados();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style>
.con-vs-popup .vs-popup {
  width: 1000px !important;
}
</style>
<!------------ END STYLE ------------>
